import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class ProjectMilestoneSessionEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ProjectMilestoneSession";
        this.primaryEnterpriseComponent = "ProjectMilestoneSession";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectMilestoneSession";
        eom.enterpriseComponent = "ProjectMilestoneSession";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ProjectMilestoneAuditHistory";
        eom.enterpriseComponent = "ProjectMilestoneAuditHistory";
        eom.relationship = "ProjectMilestoneSessionProjectMilestoneAuditHistory";
        this.enterpriseComponentMembers.set(eom.name, eom);
    }
}

export default ProjectMilestoneSessionEnterpriseObjectMetadata;